<template>

    <div class="cc-app cc-search-and-book"  v-bind:class="{ 'cc-search-and-book-inline': inline }" >

        <link v-if="settings.style_url" rel="stylesheet" :href="settings.style_url">
        
        <div class="cc-flex cc-flex-screen cc-search-and-book-popups" v-if="!inline">

            <ccAccommodationSelect v-if="!hide_accommodations" v-model="accommodation_id"></ccAccommodationSelect>
            
            <div class="cc-card mb-ms-2 cc-card-button cc-flex cc-flex-grow-1 ml-2 py-2 pr-4 pl-3 ml-ms-0" v-if="!hide_calendar" @click="showCalendarPopup = true">

                <ccIcon name='date' class="mr-4"></ccIcon>

                <span class="cc-arrival-departure cc-flex">
                    <div>{{ arrival_short }}</div>
                    <ccIcon class="cc-arrival-departure-arrow mx-2" name='arrow_right'></ccIcon> 
                    <div>{{ departure_short }}</div>
                </span> 
                
                <span class="cc-nights pl-2" v-if="settings && settings.nights">({{ settings.nights }} {{ $t('Nights')  }})</span>
            
            </div>

            <ccPopup 
            v-model="showCalendarPopup" 
            class="cc-elevation-3"
            width="380">
                
                <div class="cc-card">

                    <div class="cc-card-title">

                        <ccIcon name='date'></ccIcon>
                        
                        <div class="pl-4">{{ getPopuptitle() }}</div>

                        <div class="cc-spacer"></div>

                        <span class="cc-button-icon" @click="showCalendarPopup = false">
                            <ccIcon name='close'></ccIcon>
                        </span>

                    </div>

                    <div class="cc-divider"></div>
                    
                    <div class="cc-card-text">

                        <ccCalendar v-model="selectedDates" :accommodation_id="accommodation_id"></ccCalendar>
                    
                    </div>

                    <div class="cc-card-actions">

                        <div class="cc-button cc-button-blue" @click="showCalendarPopup = false">{{ $t('Save') }}</div>
                        <div class="cc-button ml-2" @click="showCalendarPopup = false">{{ $t('Cancel') }}</div>
                    
                    </div>

                </div>

            </ccPopup>

            <div v-if="!hide_persons"  class="cc-card mb-ms-2  cc-card-button cc-flex ml-2 py-2 pr-4 pl-3 ml-ms-0" @click="showPersonsPopup = true">

                <ccIcon name='users' class="mr-4"></ccIcon>
    
                <div class="cc-flex">
                    <span>{{ $t('Persons') }} </span> 
                    <span class="cc-nights pl-2"> ({{ personsTotal }})</span>
                </div>
            
            </div>

            <ccPopup 
            v-model="showPersonsPopup" 
            class="cc-elevation-3"
            width="546">
                
                <div class="cc-card">

                    <div class="cc-card-title">

                        <ccIcon name='date'></ccIcon>
                        
                        <div class="pl-4">{{ $t('Who is staying?') }}</div>

                        <div class="cc-spacer"></div>

                        <span class="cc-button-icon" @click="showPersonsPopup = false">
                            <ccIcon name='close'></ccIcon>
                        </span>

                    </div>

                    <div class="cc-divider"></div>
                    
                    <div class="cc-card-text pa-0">

                        <ccPersons />

                    </div>

                    <div class="cc-card-actions">

                        <div class="cc-button cc-button-blue" @click="showPersonsPopup = false">{{ $t('Save') }}</div>
                        <div class="cc-button ml-2" @click="showPersonsPopup = false">{{ $t('Cancel') }}</div>
                    
                    </div>

                </div>

            </ccPopup>

            <div 
            v-if="!hide_button"
            class="cc-button cc-button-blue ml-2" 
            v-bind:class="{ 'cc-button-loading': isLoading }"
            @click="doSearch">{{ $t('Search and Book') }}</div>
        
        </div>

        <div class="cc-card cc-search-and-book-inline" v-if="inline">

            <div class="cc-accommodations-inline" v-if="!hide_accommodations"> 
                    
                <div class="cc-card-title">

                    <ccIcon name='home'></ccIcon>
                    
                    <div class="pl-4">{{ $t('Accommodation') }}</div>

                </div>

                <div class="cc-divider"></div>
                
                <div class="cc-card-text">

                    <ccAccommodationSelect v-model="accommodation_id"></ccAccommodationSelect>
                
                </div>

            </div>

            <div class="cc-calendar-inline" v-if="!hide_calendar"> 

                <div class="cc-card-title">

                    <ccIcon name='date'></ccIcon>
                    
                    <div class="pl-4">{{ $t('Determine your stay') }}</div>

                </div>

                <div class="cc-divider"></div>
                
                <div class="cc-card-text">

                    <ccCalendar v-model="selectedDates" :accommodation_id="accommodation_id"></ccCalendar>
                
                </div>

            </div>

            <div class="cc-calendar-inline" v-if="!hide_persons"> 

                <div class="cc-card-title">

                    <ccIcon name='users'></ccIcon>
                    
                    <div class="pl-4">{{ $t('Who is staying?') }}</div>

                </div>

                <div class="cc-divider"></div>
                
                <div class="cc-card-text">

                    <ccPersons v-model="age_tables" />

                </div>

            </div>

            <div 
            v-if="!hide_button"
            class="cc-button cc-button-blue cc-button-block ma-4 mt-0 " 
            v-bind:class="{ 'cc-button-loading': isLoading }"
            @click="doSearch">{{ $t('Search and Book') }}</div>

        </div>
        <!-- <button class="cc-button cc-button-green" @click="gtmTesting">Press me!</button> -->
    </div>

</template>

<style lang="scss">

    @import "../../assets/scss/main.scss" ;

    .cc-nights {
        color: #cccccc ;
    }

    .cc-search-and-book-popups {
        width: 100%;
        max-width: 1280px;
    }

    .cc-search-and-book svg,
    .cc-search-and-book .cc-icon
    {
        vertical-align: middle;
    }

    .cc-arrival-departure-arrow.cc-icon svg
    {
        width: 16px;
        height: 16px;
        vertical-align: middle;
    }

    .cc-search-and-book-inline {
        max-width: 358px;
    }

</style>

<script>

import ccCalendar from "../../components/ccCalendar/ccCalendar" ;
import ccAccommodationSelect from "../../components/ccAccommodationSelect/ccAccommodationSelect" ;
import ccPersons from "../../components/ccPersons/ccPersons" ;

import { i18n } from "../../plugins/i18n";
import ccPopup from "../../components/ccPopup";
import ccIcon from "../../components/ccIcons";
import moment from "moment";
import helpers from "../../helpers.js"

import store from "../../store";
import { mapGetters } from "vuex";

export default {
    store,
    i18n,
    name: "BookForm",
    data () {
        return {
            showCalendarPopup: false,
            showPersonsPopup: false,
            selectedDates: null,
            // arrival_short: moment().format("DD-MM"),
            // departure_short: moment().add(7, 'days').format("DD-MM"),
            isLoading: false,
        }
    },
    components: {
        ccCalendar,
        ccAccommodationSelect,
        ccPopup,
        ccPersons,
        ccIcon
    },
    model: {
        prop: 'search_data',
        event: 'searchdata'
    },
    watch: {

        // selectedDates(){

        //     this.setShortDays() ;

        // },
        accommodation_id(){

            this.search_data.accommodation_id = this.accommodation_id ;
            this.$emit("searchdata", this.search_data);

        },
        age_tables(){
            this.search_data.age_tables = this.age_tables ;
            this.$emit("searchdata", this.search_data);
        }

    },

    computed: {

        ...mapGetters({
            settings: "app/settings",
            administration: "administration/get",
            priceCalculation: "priceCalculation/get",
            personsTotal: "priceCalculation/getTotalPersons"
        }),
        
		personsTotaal() {
            if(
                this.priceCalculation && 
                this.priceCalculation.age_table_data
                ){

                let total = 0;

                this.priceCalculation.age_table_data.forEach(age_table => {

                    if(!isNaN(age_table.count)){
                        total = total + age_table.count ;
                    }
                    
                });

                if(total > 0){
                    return total ;
                }
                

            }

            return 2 ; 			

        },
        arrival_short(){

            if(this.settings.arrival){

                return moment(this.settings.arrival, "YYYY-MM-DD").format("DD-MM") ; 

            }else{

                return '--'  ; 

            }
            
        },

        departure_short(){

            if(this.settings.departure){

                return moment(this.settings.departure, "YYYY-MM-DD").format("DD-MM") ; 

            }else{

                return '--'  ; 

            }
            
        },

	},

    created(){

        if(!store.state.app.settings.public_key){
            store.dispatch('app/init');
        }
        
        this.selectedDates = {
            arrival: moment().format("YYYY-MM-DD"),
            departure: moment().add(7, 'days').format("YYYY-MM-DD"),
            nights: 7
        };
        
    },
    methods: {
        // gtmTesting(){
        //     console.log("In here? ", this.$gtm.enabled());
        //     if(this.$gtm.enabled()){
        //         window.dataLayer?.push({
        //             event: "bookingDataUpdated"
        //         },{
        //             bookingData: {
        //                 startDate: "2021-10-10",
        //                 endDate: "2021-10-20"
        //             }
        //         })
        //     }
        // },

        doSearch(){

            this.isLoading = true ; 

            window.location.href = helpers.get_button_url('book') ; 

        },

        getPopuptitle(){

            if(this.selectedDates.nights){
                return this.selectedDates.nights + " " + this.$t('Nights') ;
            }else{
                return this.$t('Determine your stay') ;
            }

        }

    },
    props: {

        success_url: {
            type: String,
            default: null
        },
        accommodation_id: {
            type: Number,
            default: null
        },
        inline: {
            type: Boolean,
            default: false
        },
        hide_accommodations: {
            type: Boolean,
            default: false
        },
        hide_calendar: {
            type: Boolean,
            default: false
        },
        hide_persons: {
            type: Boolean,
            default: false
        },      
        hide_button: {
            type: Boolean,
            default: false
        }, 
        search_data: {
            type: Object,
            default: () => {
                return {
                    arrival: null,
                    departure: null,
                    accommodation_id: null,
                    age_tables: null
                } ;
            }
        },   

    }

}
</script>

